import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import {TbArrowBadgeLeft, TbPasswordMobilePhone} from "react-icons/tb";
import {FaSms} from "react-icons/fa";
import LogoPic from "../../Assets/Images/logo.png";

export default function VerifyOTP() {

    const [mobile] = React.useState(window.localStorage.getItem("mobile"));
    const [buttonStatus, setButtonStatus] = React.useState(window.localStorage.getItem("OTP") ? "" : "disabled",);
    const [buttonText, setButtonText] = React.useState('ورود به سامانه');
    const [loading, setLoading] = React.useState('d-none');
    const [counter, setCounter] = React.useState(120);
    const [otp, setOtp] = React.useState(window.localStorage.getItem("OTP") ? window.localStorage.getItem("OTP") : "");


    React.useEffect(() => {
        if(counter > 0) {
            setTimeout (() => {
                let second = counter - 1;
                setCounter(second);
            },1000)
        }

    }, [counter]);

    const onOTPChange = (event) => {
        const otp = event.target.value;
        if (otp.length >= 5) {
            return false;
        }
        if (otp.length === 4) {
            setButtonStatus('')
        } else {
            setButtonStatus("disabled")
        }
        setOtp(otp);
    }

    const onButtonClick =  () => {
        setButtonText("");
        setLoading("d-inline-block");
        setButtonStatus("disabled");


        API.signIn(mobile , otp)
            .then((response) => {
                toast.success(response.message);
                window.localStorage.removeItem("mobile");
                window.localStorage.removeItem("OTP");
                if(response.data.needRegistration > 0) {
                    window.localStorage.setItem("needRegistration", 'on');
                }

                const expire_date = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
                document.cookie = `auth=${response.data.token}; expires=${expire_date}; path=/`;
                setTimeout (() => {
                    response.data.needRegistration > 0 ? window.location.replace('/register') : window.location.replace('/home')
                },1500)

            })
            .catch((error) => {
                toast.error(error.response.data.message)
                setButtonText("ورود به سامانه");
                setLoading("d-none")
                setButtonStatus('')

            });
    }

    const onResendClick = () => {
        const request = {
            mobile,
            'processFor' : 'Guardians'
        }
        API.signUp(request)
            .then((response) => {
                toast.success(response.message);
                if(response.data.otp) {
                    window.localStorage.setItem("OTP", response.data.otp);
                    setOtp(response.data.otp);
                }
                setCounter(180)
            })
            .catch((error) => {

            });
    }
    return (
        <React.Fragment>

            <Toast />

            <main>
                <div className="container rtl">

                    <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">

                                    <div className="d-flex justify-content-center py-4">
                                        <a href="index.html" className="logo d-flex align-items-center w-auto">
                                            <span className="d-none d-lg-block mx-2 text-small-1">NGKH</span>
                                            <img src={LogoPic} alt="نیروگستران" className="rounded mx-auto " />

                                        </a>
                                    </div>

                                    <div className="card mb-3 py-5 px-2 ">

                                        <div className="card-body">

                                            <div className="pt-4 pb-2">
                                                <h5 className="card-title text-center pb-0 fs-4 mb-3 ">
                                                    تایید شماره موبایل
                                                </h5>
                                                <p className="text-center text-small-2  text-secondary">
                                                    کد ارسالی به موبایل
                                                    &nbsp;
                                                    <strong>
                                                        {mobile}
                                                    </strong>
                                                    &nbsp;
                                                    را وارد نمایید
                                                </p>
                                            </div>

                                            <div className="row g-3 needs-validation" >

                                                <div className="col-12 ">
                                                    <label htmlFor="yourUsername" className="form-label text-small-2 text-muted">کد تایید </label>
                                                    <div className="input-group has-validation ltr">
                                                        <span className="input-group-text" id="inputGroupPrepend">
                                                            <TbPasswordMobilePhone   />
                                                        </span>
                                                        <input type="text" name="username" className="form-control" id="yourUsername"
                                                               value={otp}
                                                               onChange={onOTPChange}
                                                        />
                                                        <div className="invalid-feedback">
                                                            کد ارسالی به موبایل
                                                            &nbsp;
                                                            <strong>
                                                                {mobile}
                                                            </strong>
                                                            &nbsp;
                                                            را وارد نمایید
                                                        </div>
                                                    </div>
                                                </div>



                                                <div className="col-12 mt-5">
                                                    <button
                                                        className="btn btn-warning  text-center text-small-2 text-white  w-100 pt-3 "
                                                        onClick={onButtonClick}
                                                        disabled={buttonStatus}
                                                    >
                                                        {buttonText}
                                                        <span className="badge  p-2 float-start">
<TbArrowBadgeLeft className='text-big-3' />
                    </span>
                                                        <span  className={"spinner-grow spinner-grow-sm " + loading} role="status"
                                                               aria-hidden="true">

                            </span>
                                                    </button>
                                                </div>
                                                <div className="col-12 text-center  ">
                                                    {counter ? <div className="rtl mt-2 text-center text-small-3 text-secondary">
                                                        {counter}
                                                        &nbsp;
                                                        ثانیه
                                                        تا امکان درخواست مجدد کد تایید
                                                    </div> : <span></span>}
                                                    {!counter &&
                                                        <div className="rtl mt-4 text-center text-info pointer text-small-2  "
                                                             role='button'
                                                             onClick={onResendClick}>
                                                            <FaSms />

                                                            &nbsp;
                                                            ارسال مجدد کد تایید
                                                        </div>}

                                                </div>
                                            </div>

                                        </div>
                                    </div>



                                </div>
                            </div>
                        </div>

                    </section>

                </div>
            </main>
        </React.Fragment>
    );
}
